const groupPrefix = 'groups'

export const apiSegmentGroups = {
	fetchSingleGroup: async (groupID: number | string) => {
		const { data } = await apiCommon<IProductGroup>(`${groupPrefix}/${groupID}`, { method: 'GET' })
		return ProductGroup(data)
	},

	fetchAllGroups: async () => {
		const { data, links } = await apiCommon<IProductGroup[]>(`${groupPrefix}`, {
			method: 'GET',
		})

		if (!data) return { data: [], links }
		const response = data.map((product) => {
			return ProductGroup(product)
		})
		return { data: response, links }
	},

	updateSegmentsInGroup: async (groupID: string, segments: any[]) => {
		const { data } = await apiCommon<IProductGroup>(`${groupPrefix}/${groupID}`, { method: 'PUT', body: { segments } })
		return ProductGroup(data)
	},

	deleteSegmentFromGroup: async (groupID: string) => {
		const data = await apiCommon<string>(`${groupPrefix}/${groupID}`, { method: 'DELETE' })
		return data
	},
}
